export default "__VITE_ASSET__CUP69Gy5__"